<page-title text="Page Error | BitOasis" i18n-text="@@pageTitle.noWallet"></page-title>
<site-layout class="narrow push">
    <h2 class="text-header text-bold text-center mb-2" i18n="@@front.noWallet.title">Error Creating Wallet</h2>
    <div class="p-3"></div>
  
    <auth-no-wallet></auth-no-wallet>
</site-layout>